<template>
  <custom-plane>
    <div class="table-top">
      <div class="name">分户能耗情况</div>
    </div>
    <div class="table-search">
      <div class="top-select">
        <el-select
          v-model="selectValue"
          placeholder="请选择"
          @change="selectOptionChange"
        >
          <el-option
            v-for="item in selectOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="top-input">
        <template v-if="selectVal">
          <el-input
            placeholder="请输入设备名称"
            v-model="searchValue1"
            clearable
            @clear="getRecentData"
          >
          </el-input>
        </template>
        <template v-else>
          <el-autocomplete
            class="inline-input"
            v-model="searchValue2"
            :fetch-suggestions="querySearch"
            placeholder="请输入企业名称"
            @select="handleSelect"
            clearable
            @clear="getRecentData"
          ></el-autocomplete>
        </template>
      </div>
      <div class="top-btn" @click="chooseTable" ref="test">搜索</div>
    </div>

    <div class="bot-table">
      <div class="custom-table-header">
        <div
          class="table-column-item"
          :style="getRowStyle(item)"
          v-for="(item, index) in header"
          @click="changeUp(item)"
          :key="'x' + index"
        >
          <div class="text">
            <div class="text-name">{{ item.name }}</div>
            <div class="text-unit">{{ item.unit }}</div>
            <div
              class="text-img"
              :class="item.isUp == 0 ? '' : 'text-img-up'"
              v-if="item.flag == 1"
            ></div>
          </div>
        </div>
      </div>
      <template v-if="tableData.length != 0">
        <div class="custom-table-body mens" ref="listsTable">
          <div
            class="custom-table-item"
            :class="{
              menoff: getMenoff(index),
              itemSelect: data.eqpName == selectIndex,
            }"
            v-for="(data, index) in showData"
            @click="clickEvent(data, index)"
            :key="'c' + index"
          >
            <div
              class="table-column-item"
              ref="tableItemRef"
              :style="getRowStyle(item)"
              v-for="(item, index) in header"
              :key="'xx' + index"
            >
              <el-tooltip
                class="box-item"
                effect="dark"
                :content="String(setBuildNum(data[item.key], item.key))"
                placement="bottom-start"
              >
                <div class="text">
                  {{ setBuildNum(data[item.key], item.key) }}
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="isLoadEnd">
        <div class="bot-bg">
          <div class="bot-bg-hidden"></div>
          <div class="bot-bg-name">暂无数据</div>
        </div>
      </template>
      <template v-else>
        <div class="bot-bg">
          <div class="bot-bg-hidden">
            <div class="loading">
              <div class="outer"></div>
              <div class="middle"></div>
              <div class="inner"></div>
            </div>
          </div>
          <div class="bot-bg-name">数据加载中...</div>
        </div>
      </template>
    </div>
  </custom-plane>
</template>

<script>
import bus from "@/components/three-scene/Bus.js";
import { getMerchanName } from "@/api/index.js";
export default {
  name: "custom-table",
  props: {
    areaNum: String,
    header: Array,
    tableData: Array,
    isLoadEnd: Boolean,
  },

  data() {
    return {
      selectIndex: null,
      selectValue: "搜设备",
      company: [],
      selectOptions: [
        {
          value: "搜设备",
          label: "搜设备",
        },
        {
          value: "搜企业",
          label: "搜企业",
        },
      ],
      searchValue1: "", //设备
      searchValue2: "", //企业
      isUp: false,
      search: "",
      headerMap: {
        "01": "A1",
        "02": "A2",
        "03": "B1B2",
        "04": "B3",
        "05": "A区地下室",
        "06": "B区地下室",
        // 'A':'A地下室',
        // 'B':'B地下室',
        // 'C':'C',
        // 'D':'D',
        // '人防':'人防',
      },
      arr: [],
      sortMap: ["descending", "ascending"],
      daySort: true,
      dayUp: 0,
      monthSort: false,
      monthUp: 0,
      startValue: 0,
      endValue: 0,
      isScroll: false,
      isHidden: false,
    };
  },
  computed: {
    selectVal() {
      return this.selectValue === "搜设备";
    },
    showData() {
      if (this.tableData.length == 0) {
        return [];
      }
      this.arr = this.tableData.filter((item) => {
        // console.log(item.buildNo,'build');
        let bulidNo = "";

        if (this.areaNum != "总") {
          bulidNo = this.areaNum;
          //  this.areaNum=null;
        }
        if (this.selectValue == "搜设备") {
          if (item.eqpName.includes(this.search)) {
            if (
              (bulidNo.includes("地下室") &&
                this.headerMap[item.buildNo].includes("地下室")) ||
              this.headerMap[item.buildNo].includes(bulidNo)
            ) {
              return item;
            }
          }
        } else {
          if (item.merchantName.includes(this.search)) {
            if (
              (bulidNo.includes("地下室") &&
                this.headerMap[item.buildNo].includes("地下室")) ||
              this.headerMap[item.buildNo].includes(bulidNo)
            ) {
              return item;
            }
          }
        }

        // if(item.)
      });
      // if (this.arr.length == 0) {
      //   this.stopScroll();
      // }
      if (this.daySort) {
        this.setSort(this.dayUp, "energyDay");
      }
      if (this.monthSort) {
        this.setSort(this.monthUp, "energyMonth");
      }
      return this.arr;
    },
  },
  async mounted() {
    this.company = await this.loadAll();
  },
  methods: {
    selectOptionChange() {
      this.getRecentData();
      this.searchValue1 = "";
      this.searchValue2 = "";
    },
    querySearch(queryString, cb) {
      var company = this.company;
      var results = queryString
        ? company.filter(this.createFilter(queryString))
        : company;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    async loadAll() {
      let result = [];
      let { data: res } = await getMerchanName();
      res.map((company) => {
        result.push({
          value: company,
          name: company,
        });
      });
      return result;
    },
    handleSelect(item) {
      console.log(item, "ssss");
    },
    changeFloor(value) {
      if (value.includes("A")) {
        return "F" + value.slice(2);
      }
      if (value.includes("B")) {
        return "-" + "F" + value.slice(2);
      }
    },
    clickEvent(data, i) {
      this.selectIndex = data.eqpName;
      if (data.floor.includes("B")) {
        bus.emit("chooseParkingPoint", data.eqpCode, "能耗");
      } else {
        bus.emit(
          "chooseFloorPoint",
          this.headerMap[data.buildNo],
          this.changeFloor(data.floor),
          data.eqpCode,
          "能耗"
        );
      }
    },
    getMenoff(index) {
      if (this.startValue % 2 == 0) {
        return index % 2 !== 0;
      } else {
        return index % 2 == 0;
      }
    },
    scrollEvent(e) {
      let scrollTop = e.target.scrollTop;
      this.startValue = Math.floor(scrollTop / 46);
      this.endValue = this.startValue + 14;
      let domStyle = this.$refs.tableWatch.style;
      domStyle.top = this.startValue * 46 + "px";
    },
    setSort(value, key) {
      if (value == 1) {
        this.arr.sort((a, b) => {
          return a[key] - b[key];
        });
      } else {
        this.arr.sort((a, b) => {
          return b[key] - a[key];
        });
      }
    },
    setBuildNum(value, key) {
      if (key == "buildNo") {
        if (value == "") {
          return "";
        }
        return this.headerMap[value];
      }
      if (key == "floor") {
        if (value) {
          if (value.includes("A")) {
            return value.slice(2) + "F";
          }
          if (value.includes("B")) {
            return "-" + value.slice(2) + "F";
          }
        }
      }
      return value;
    },

    getRecentData() {
      this.search = "";
      this.isScroll = false;
      // this.autoScroll();
    },
    setNegation(key) {
      if (this[key] == 0) {
        this[key] = 1;
      } else {
        this[key] = 0;
      }
    },
    changeUp(item) {
      if (item.isUp == 0) {
        item.isUp = 1;
      } else {
        item.isUp = 0;
      }
      if (item.key == "energyDay") {
        this.daySort = true;
        this.monthSort = false;
        this.setNegation("dayUp");
      }
      if (item.key == "energyMonth") {
        this.daySort = false;
        this.monthSort = true;
        this.setNegation("monthUp");
      }
    },
    chooseTable() {
      if (this.selectValue == "搜设备") {
        this.search = this.searchValue1;
      } else {
        this.search = this.searchValue2;
      }

      this.isScroll = true;
      console.log(this.tableData.length);
      let dom = this.$refs.listsTable;
      dom.scrollTop = 0;
      this.$refs.tableWrap.style.height = 0;
      // let dom1 = document.getElementsByClassName("custom-table-item");
      // // console.log(dom1,'dom1');
      // // let a=dom1[dom1.length-1]
      // // console.log(dom1[dom1.length-1],'dom');
      // // console.log(a.offsetHeight);
      // if (dom1.clientHeight < dom.clientHeight) {
      //   this.isHidden = true;
      // }
      // this.stopScroll();
    },
    getRowStyle(item) {
      return {
        width: item.width + "px",
      };
    },
    // autoScroll() {
    //   if (this.isScroll) {
    //     return;
    //   }
    //   Scroll(this.$refs.listsTable, "ad");
    // },
    // stopScroll() {
    //   Stop("ad");
    // },
  },
};
</script>

<style lang="scss">
.el-autocomplete-suggestion {
  width: 264px !important;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(5px);
  overflow-x: hidden;
  .el-autocomplete-suggestion__wrap {
    padding: 8px 0;
    overflow-x: hidden;
  }
}
.el-autocomplete-suggestion li {
  height: 29px;
  color: #fff;
  font-size: 14px;
}
.el-autocomplete-suggestion li.hover,
.el-autocomplete-suggestion li:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.popper__arrow {
  display: none !important;
}
.el-select-dropdown {
  // margin-top: -10px;
  width: 128px;
  backdrop-filter: blur(10px);
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    radial-gradient(
      163.91% 118.33% at 50.24% 47.78%,
      rgba(241, 128, 47, 0.1) 0%,
      rgba(27, 154, 255, 0.1) 100%
    );
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  .el-select-dropdown__item {
    color: #c4c4c4;
    height: 29px;
  }
}
.el-select-dropdown__list {
  padding: 8px 0 !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.el-select-dropdown__item.selected {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.el-scrollbar {
  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
.top-select {
  .el-select {
    width: 69px;
    height: 32px;
    .el-input--suffix .el-input__inner {
      height: 32px;
      border-color: rgba(255, 255, 255, 0.5);
      padding: 0 8px;
      background: rgba(0, 0, 0, 0.2);
      color: #fff;
      font-weight: 400;
      font-size: 14px;
      border-radius: 0;
    }
    .el-input__prefix,
    .el-input__suffix {
      .el-input__suffix-inner {
        .el-input__icon {
          width: 13px;
        }
        i {
          color: #fff;
          line-height: 32px;
        }
        .el-input__icon:after {
          width: 7px;
        }
      }
    }
  }
}
.top-input {
  .el-input {
    width: 247px;
    height: 32px;
    .el-input__suffix {
      position: absolute;
      top: -3px;
    }
    .el-input__inner {
      padding-left: 12px;
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid rgba(255, 255, 255, 0.1);
      height: 32px;
      border-radius: 0;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;
      line-height: 21px;
    }
  }
}
</style>
<style lang="scss" scoped>
.itemSelect {
  background: rgba(45, 130, 255, 0.6) !important;
}
.text-left {
  text-align: left !important;
}
.menoff {
  width: 416px;
  // height: 38px;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
}
.table-top {
  margin: 10px 20px;
  display: flex;
  align-items: center;
  height: 40px;
  .name {
    white-space: nowrap;
    font-weight: 400;
    font-size: 18px;
    line-height: 18px;
    color: #fff;
    margin-right: 27px;
  }
}
.table-search {
  margin-left: 20px;
  display: flex;
  align-items: center;
  .top-select {
    width: 69px;
    height: 32px;
  }
  .top-input {
    margin-left: 8px;
    width: 247px;
    height: 32px;
  }
  .top-btn {
    width: 52px;
    height: 32px;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    cursor: pointer;
  }
}
.hidden-table {
  overflow: hidden;
}
.bot-table {
  // position: relative;
  height: 552px;
  overflow: hidden;
  margin: 10px 20px;
  .mens {
    height: 552px;
    overflow-x: hidden;
    // overflow: hidden;
  }
  .custom-table-header {
    width: 100%;
    height: 42px;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
    .table-column-item {
      height: 100%;
      display: flex;
      align-items: center;
      text-align: center;
      cursor: pointer;
      .text {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        .text-name {
          color: #ffffff;
          line-height: 18px;
          font-size: 14px;
        }
        .text-unit {
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
          line-height: 11px;
          transform: scale(0.83);
        }
        .text-img {
          margin-left: 2px;
          width: 6px;
          height: 10px;
          background-image: url("../../assets/cut/down.png");
          background-size: cover;
        }
        .text-img-up {
          transform: rotate(180deg);
        }
      }
    }
  }
  .custom-table-body {
    flex-grow: 1;
    position: relative;
    padding-bottom: 50px;
    .custom-table-wrap {
      position: absolute;
      top: 0;
      left: 0;
    }
    .custom-table-watch {
      position: absolute;
      top: 0;
      left: 0;
    }
    .custom-table-item {
      width: 416px;
      height: 46px;
      overflow: hidden;
      display: flex;
      align-items: center;
      .table-column-item {
        text-align: center;
        word-break: break-all;
        white-space: pre-wrap;
        line-height: 18px;
        display: -webkit-box; //谷歌
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; //显示几行
        overflow: hidden;
      }
      .text {
        font-size: 14px;
        line-height: 18px;
      }
      .table-column-properties {
        flex: 0;
      }
    }
  }
  .bot-bg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 564px;
    overflow: hidden;
    .bot-bg-hidden {
      background-image: url("../../assets/public/not-show.png");
      background-size: cover;
      width: 100px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      .loading {
        width: 36px;
        height: 36px;
        position: relative;
        font-size: 12px;
      }
      .outer,
      .middle,
      .inner {
        border: 3px solid transparent;
        border-top-color: #d9d9d9;
        border-right-color: #d9d9d9;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
      }

      .outer {
        width: 3.5em;
        height: 3.5em;
        margin-left: -1.75em;
        margin-top: -1.75em;
        animation: spin 4s linear infinite;
      }

      .middle {
        width: 2.1em;
        height: 2.1em;
        margin-left: -1.05em;
        margin-top: -1.05em;
        animation: spin 3s linear reverse infinite;
      }

      .inner {
        width: 0.8em;
        height: 0.8em;
        margin-left: -0.4em;
        margin-top: -0.4em;
        animation: spin 2s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    }
    .bot-bg-name {
      margin-top: 14px;
      font-weight: 400;
      font-size: 16px;
      line-height: 18px;
      color: #afafaf;
    }
  }
}
</style>
